import axios from "axios";

import { LMS_TOKEN } from "../../../../utils/cookiesmanager";
import { LMS_BASE_URL } from "../../../../utils/http/http-common";

export const getChapterByModuleApiCall = async (args) => {
  const { courseId = 1, languageId = 1, moduleId = 1 } = args;

  const authToken = localStorage.getItem(LMS_TOKEN);

  try {
    const response = await axios.get(
      `${LMS_BASE_URL}/chapter/by-module?courseId=${courseId}&languageId=${languageId}&moduleId=${moduleId}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      },
    );
    return response;
  } catch (error) {
    return error.config.data;
  }
};
